import { useNavigate } from 'react-router-dom';
import { Button, Divider, Modal } from 'antd';

import { useAppDispatch, useAppSelector } from '@/core/redux/hooks';
import { systemModalsSelectors } from '@/core/redux/slices/modals/smokeExtraction/system/selectors';
import { systemModalsActions } from '@/core/redux/slices/modals/smokeExtraction/system/slice';

const ModalContent: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isRender } = useAppSelector(
    systemModalsSelectors.subscriptionRequestModal
  );

  const handleCancel = () => {
    dispatch(systemModalsActions.closeSubscriptionRequestModal());
  };

  const handleAction = () => {
    dispatch(systemModalsActions.closeSubscriptionRequestModal());
    navigate('/profile/subscription');
  };

  return (
    <Modal
      open={isRender}
      destroyOnClose
      onCancel={handleCancel}
      closable={false}
      centered
      footer={null}
    >
      Включите подписку, чтобы получить доступ к разделу
      <Divider />
      <Button className='w-full' type='primary' onClick={handleAction}>
        Выбрать подписку
      </Button>
    </Modal>
  );
};

export const SubscriptionRequestModal: React.FC = () => {
  const { isRender } = useAppSelector(
    systemModalsSelectors.subscriptionRequestModal
  );

  if (isRender) {
    return <ModalContent />;
  }

  return null;
};
